import { render, staticRenderFns } from "./CarEdit.vue?vue&type=template&id=afcf60b6&"
import script from "./CarEdit.vue?vue&type=script&lang=js&"
export * from "./CarEdit.vue?vue&type=script&lang=js&"
import style0 from "./CarEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports